module.exports = __webpack_public_path__ + "static/media/3d.7670b6ac.jpg";